import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Tooltip, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ROUTES } from 'constants.js';
import { WalletIcon } from 'components/Shared/Icons';
import Can from 'config/Can';
import useTranslation from 'utils/hooks/useTranslation';
import useAmplitude from 'utils/hooks/useAmplitude';
import useGetSupportLink from 'utils/hooks/useGetSupportLink';
import { AMPLITUDE_EVENT_TYPES, AMPLITUDE_WALLET_PROPERTY_VALUES } from 'constants/amplitude';

import styles from './style.module.scss';

const WalletEmptyState = () => {
  const { translateText } = useTranslation();
  const history = useHistory();
  const { sendAmplitudeEvent } = useAmplitude();
  const supportLink = useGetSupportLink();

  const handleCreateWallet = () => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletCreateStartButtonClicked, {
      source: AMPLITUDE_WALLET_PROPERTY_VALUES.source.emptyState,
    });
    history.push(ROUTES.WALLET_CREATE);
  };

  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyIconCircle}>
        <WalletIcon />
      </div>
      <Typography.Title className={styles.emptyStateTitle}>
        {translateText('corporateAccounts.wallet.emptyState.title')}
      </Typography.Title>
      <Typography className={styles.emptyStateDescription}>
        {translateText('corporateAccounts.wallet.emptyState.description')}
      </Typography>
      <Can I="create" a="Wallet" passThrough>
        {allowed => (
          <Tooltip
            title={
              allowed ? null : translateText('corporateAccounts.wallet.emptyState.createDisabled')
            }
          >
            <span>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                className={styles.createWalletButton}
                data-testid="createWalletButton"
                disabled={!allowed}
                onClick={handleCreateWallet}
              >
                {translateText('corporateAccounts.wallet.emptyState.createButton')}
              </Button>
            </span>
          </Tooltip>
        )}
      </Can>
      <Typography className={styles.emptyStateFootnote}>
        {translateText('corporateAccounts.wallet.emptyState.footnote')}
      </Typography>
      <div className={styles.emptyStateFooter} data-testid="walletEmptyStateFooter">
        {translateText('corporateAccounts.wallet.emptyState.contactSales', {
          contactSalesLink: (
            <a
              href={supportLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.contactSalesLink}
              data-testid="walletContactSalesLink"
            >
              {translateText('corporateAccounts.common.contactSales')}
            </a>
          ),
        })}
      </div>
    </div>
  );
};

export default WalletEmptyState;
